"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinners = {
    arc: {
        frames: ['◜', '◠', '◝', '◞', '◡', '◟'],
        interval: 100,
    },
    arrow: {
        frames: ['←', '↖', '↑', '↗', '→', '↘', '↓', '↙'],
        interval: 100,
    },
    arrow2: {
        frames: ['⬆️ ', '↗️ ', '➡️ ', '↘️ ', '⬇️ ', '↙️ ', '⬅️ ', '↖️ '],
        interval: 80,
    },
    arrow3: {
        frames: ['▹▹▹▹▹', '▸▹▹▹▹', '▹▸▹▹▹', '▹▹▸▹▹', '▹▹▹▸▹', '▹▹▹▹▸'],
        interval: 120,
    },
    balloon: {
        frames: [' ', '.', 'o', 'O', '@', '*', ' '],
        interval: 140,
    },
    balloon2: {
        frames: ['.', 'o', 'O', '°', 'O', 'o', '.'],
        interval: 120,
    },
    bounce: {
        frames: ['⠁', '⠂', '⠄', '⠂'],
        interval: 120,
    },
    bouncingBall: {
        frames: [
            '( ●        )',
            '(    ●     )',
            '(     ●    )',
            '(        ● )',
            '(         ●)',
            '(        ● )',
            '(     ●    )',
            '(    ●     )',
            '( ●        )',
            '(●         )',
        ],
        interval: 80,
    },
    bouncingBar: {
        frames: [
            '[        ]',
            '[=     ]',
            '[==    ]',
            '[=== ]',
            '[ ===]',
            '[    ==]',
            '[     =]',
            '[        ]',
            '[     =]',
            '[    ==]',
            '[ ===]',
            '[====]',
            '[=== ]',
            '[==    ]',
            '[=     ]',
        ],
        interval: 80,
    },
    boxBounce: {
        frames: ['▖', '▘', '▝', '▗'],
        interval: 120,
    },
    boxBounce2: {
        frames: ['▌', '▀', '▐', '▄'],
        interval: 100,
    },
    christmas: {
        frames: ['🌲', '🎄'],
        interval: 400,
    },
    circle: {
        frames: ['◡', '⊙', '◠'],
        interval: 120,
    },
    circleHalves: {
        frames: ['◐', '◓', '◑', '◒'],
        interval: 50,
    },
    circleQuarters: {
        frames: ['◴', '◷', '◶', '◵'],
        interval: 120,
    },
    clock: {
        frames: [
            '🕐 ',
            '🕑 ',
            '🕒 ',
            '🕓 ',
            '🕔 ',
            '🕕 ',
            '🕖 ',
            '🕗 ',
            '🕘 ',
            '🕙 ',
            '🕚 ',
        ],
        interval: 100,
    },
    dots: {
        frames: ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'],
        interval: 80,
    },
    dots2: {
        frames: ['⣾', '⣽', '⣻', '⢿', '⡿', '⣟', '⣯', '⣷'],
        interval: 80,
    },
    dots3: {
        frames: ['⠋', '⠙', '⠚', '⠞', '⠖', '⠦', '⠴', '⠲', '⠳', '⠓'],
        interval: 80,
    },
    dots4: {
        frames: [
            '⠄',
            '⠆',
            '⠇',
            '⠋',
            '⠙',
            '⠸',
            '⠰',
            '⠠',
            '⠰',
            '⠸',
            '⠙',
            '⠋',
            '⠇',
            '⠆',
        ],
        interval: 80,
    },
    dots5: {
        frames: [
            '⠋',
            '⠙',
            '⠚',
            '⠒',
            '⠂',
            '⠂',
            '⠒',
            '⠲',
            '⠴',
            '⠦',
            '⠖',
            '⠒',
            '⠐',
            '⠐',
            '⠒',
            '⠓',
            '⠋',
        ],
        interval: 80,
    },
    dots6: {
        frames: [
            '⠁',
            '⠉',
            '⠙',
            '⠚',
            '⠒',
            '⠂',
            '⠂',
            '⠒',
            '⠲',
            '⠴',
            '⠤',
            '⠄',
            '⠄',
            '⠤',
            '⠴',
            '⠲',
            '⠒',
            '⠂',
            '⠂',
            '⠒',
            '⠚',
            '⠙',
            '⠉',
            '⠁',
        ],
        interval: 80,
    },
    dots7: {
        frames: [
            '⠈',
            '⠉',
            '⠋',
            '⠓',
            '⠒',
            '⠐',
            '⠐',
            '⠒',
            '⠖',
            '⠦',
            '⠤',
            '⠠',
            '⠠',
            '⠤',
            '⠦',
            '⠖',
            '⠒',
            '⠐',
            '⠐',
            '⠒',
            '⠓',
            '⠋',
            '⠉',
            '⠈',
        ],
        interval: 80,
    },
    dots8: {
        frames: [
            '⠁',
            '⠁',
            '⠉',
            '⠙',
            '⠚',
            '⠒',
            '⠂',
            '⠂',
            '⠒',
            '⠲',
            '⠴',
            '⠤',
            '⠄',
            '⠄',
            '⠤',
            '⠠',
            '⠠',
            '⠤',
            '⠦',
            '⠖',
            '⠒',
            '⠐',
            '⠐',
            '⠒',
            '⠓',
            '⠋',
            '⠉',
            '⠈',
            '⠈',
        ],
        interval: 80,
    },
    dots9: {
        frames: ['⢹', '⢺', '⢼', '⣸', '⣇', '⡧', '⡗', '⡏'],
        interval: 80,
    },
    dots10: {
        frames: ['⢄', '⢂', '⢁', '⡁', '⡈', '⡐', '⡠'],
        interval: 80,
    },
    dots11: {
        frames: ['⠁', '⠂', '⠄', '⡀', '⢀', '⠠', '⠐', '⠈'],
        interval: 100,
    },
    dots12: {
        frames: [
            '⢀⠀',
            '⡀⠀',
            '⠄⠀',
            '⢂⠀',
            '⡂⠀',
            '⠅⠀',
            '⢃⠀',
            '⡃⠀',
            '⠍⠀',
            '⢋⠀',
            '⡋⠀',
            '⠍⠁',
            '⢋⠁',
            '⡋⠁',
            '⠍⠉',
            '⠋⠉',
            '⠋⠉',
            '⠉⠙',
            '⠉⠙',
            '⠉⠩',
            '⠈⢙',
            '⠈⡙',
            '⢈⠩',
            '⡀⢙',
            '⠄⡙',
            '⢂⠩',
            '⡂⢘',
            '⠅⡘',
            '⢃⠨',
            '⡃⢐',
            '⠍⡐',
            '⢋⠠',
            '⡋⢀',
            '⠍⡁',
            '⢋⠁',
            '⡋⠁',
            '⠍⠉',
            '⠋⠉',
            '⠋⠉',
            '⠉⠙',
            '⠉⠙',
            '⠉⠩',
            '⠈⢙',
            '⠈⡙',
            '⠈⠩',
            '⠀⢙',
            '⠀⡙',
            '⠀⠩',
            '⠀⢘',
            '⠀⡘',
            '⠀⠨',
            '⠀⢐',
            '⠀⡐',
            '⠀⠠',
            '⠀⢀',
            '⠀⡀',
        ],
        interval: 80,
    },
    dqpb: {
        frames: ['d', 'q', 'p', 'b'],
        interval: 100,
    },
    earth: {
        frames: ['🌍 ', '🌎 ', '🌏 '],
        interval: 180,
    },
    flip: {
        frames: ['_', '_', '_', '-', '`', '`', "'", '´', '-', '_', '_', '_'],
        interval: 70,
    },
    growHorizontal: {
        frames: ['▏', '▎', '▍', '▌', '▋', '▊', '▉', '▊', '▋', '▌', '▍', '▎'],
        interval: 120,
    },
    growVertical: {
        frames: ['▁', '▃', '▄', '▅', '▆', '▇', '▆', '▅', '▄', '▃'],
        interval: 120,
    },
    hamburger: {
        frames: ['☱', '☲', '☴'],
        interval: 100,
    },
    hearts: {
        frames: ['💛 ', '💙 ', '💜 ', '💚 ', '❤️ '],
        interval: 100,
    },
    line: {
        frames: ['-', '\\', '|', '/'],
        interval: 130,
    },
    line2: {
        frames: ['⠂', '-', '–', '—', '–', '-'],
        interval: 100,
    },
    monkey: {
        frames: ['🙈 ', '🙈 ', '🙉 ', '🙊 '],
        interval: 300,
    },
    moon: {
        frames: ['🌑 ', '🌒 ', '🌓 ', '🌔 ', '🌕 ', '🌖 ', '🌗 ', '🌘 '],
        interval: 80,
    },
    noise: {
        frames: ['▓', '▒', '░'],
        interval: 100,
    },
    pipe: {
        frames: ['┤', '┘', '┴', '└', '├', '┌', '┬', '┐'],
        interval: 100,
    },
    pong: {
        frames: [
            '▐⠂             ▌',
            '▐⠈             ▌',
            '▐ ⠂            ▌',
            '▐ ⠠            ▌',
            '▐    ⡀         ▌',
            '▐    ⠠         ▌',
            '▐     ⠂        ▌',
            '▐     ⠈        ▌',
            '▐        ⠂     ▌',
            '▐        ⠠     ▌',
            '▐         ⡀    ▌',
            '▐         ⠠    ▌',
            '▐            ⠂ ▌',
            '▐            ⠈ ▌',
            '▐             ⠂▌',
            '▐             ⠠▌',
            '▐             ⡀▌',
            '▐            ⠠ ▌',
            '▐            ⠂ ▌',
            '▐         ⠈    ▌',
            '▐         ⠂    ▌',
            '▐        ⠠     ▌',
            '▐        ⡀     ▌',
            '▐     ⠠        ▌',
            '▐     ⠂        ▌',
            '▐    ⠈         ▌',
            '▐    ⠂         ▌',
            '▐ ⠠            ▌',
            '▐ ⡀            ▌',
            '▐⠠             ▌',
        ],
        interval: 80,
    },
    runner: {
        frames: ['🚶 ', '🏃 '],
        interval: 140,
    },
    shark: {
        frames: [
            '▐|\\____________▌',
            '▐_|\\___________▌',
            '▐__|\\__________▌',
            '▐___|\\_________▌',
            '▐____|\\________▌',
            '▐_____|\\_______▌',
            '▐______|\\______▌',
            '▐_______|\\_____▌',
            '▐________|\\____▌',
            '▐_________|\\___▌',
            '▐__________|\\__▌',
            '▐___________|\\_▌',
            '▐____________|\\▌',
            '▐____________/|▌',
            '▐___________/|_▌',
            '▐__________/|__▌',
            '▐_________/|___▌',
            '▐________/|____▌',
            '▐_______/|_____▌',
            '▐______/|______▌',
            '▐_____/|_______▌',
            '▐____/|________▌',
            '▐___/|_________▌',
            '▐__/|__________▌',
            '▐_/|___________▌',
            '▐/|____________▌',
        ],
        interval: 120,
    },
    simpleDots: {
        frames: ['.    ', '.. ', '...', '     '],
        interval: 400,
    },
    simpleDotsScrolling: {
        frames: ['.    ', '.. ', '...', ' ..', '    .', '     '],
        interval: 200,
    },
    smiley: {
        frames: ['😄 ', '😝 '],
        interval: 200,
    },
    squareCorners: {
        frames: ['◰', '◳', '◲', '◱'],
        interval: 180,
    },
    squish: {
        frames: ['╫', '╪'],
        interval: 100,
    },
    star: {
        frames: ['✶', '✸', '✹', '✺', '✹', '✷'],
        interval: 70,
    },
    star2: {
        frames: ['+', 'x', '*'],
        interval: 80,
    },
    toggle: {
        frames: ['⊶', '⊷'],
        interval: 250,
    },
    toggle2: {
        frames: ['▫', '▪'],
        interval: 80,
    },
    toggle3: {
        frames: ['□', '■'],
        interval: 120,
    },
    toggle4: {
        frames: ['■', '□', '▪', '▫'],
        interval: 100,
    },
    toggle5: {
        frames: ['▮', '▯'],
        interval: 100,
    },
    toggle6: {
        frames: ['ဝ', '၀'],
        interval: 300,
    },
    toggle7: {
        frames: ['⦾', '⦿'],
        interval: 80,
    },
    toggle8: {
        frames: ['◍', '◌'],
        interval: 100,
    },
    toggle9: {
        frames: ['◉', '◎'],
        interval: 100,
    },
    toggle10: {
        frames: ['㊂', '㊀', '㊁'],
        interval: 100,
    },
    toggle11: {
        frames: ['⧇', '⧆'],
        interval: 50,
    },
    toggle12: {
        frames: ['☗', '☖'],
        interval: 120,
    },
    toggle13: {
        frames: ['=', '*', '-'],
        interval: 80,
    },
    triangle: {
        frames: ['◢', '◣', '◤', '◥'],
        interval: 50,
    },
    weather: {
        frames: [
            '☀️ ',
            '☀️ ',
            '☀️ ',
            '🌤 ',
            '⛅️ ',
            '🌥 ',
            '☁️ ',
            '🌧 ',
            '🌨 ',
            '🌧 ',
            '🌨 ',
            '🌧 ',
            '🌨 ',
            '⛈ ',
            '🌨 ',
            '🌧 ',
            '🌨 ',
            '☁️ ',
            '🌥 ',
            '⛅️ ',
            '🌤 ',
            '☀️ ',
            '☀️ ',
        ],
        interval: 100,
    },
    yellowbrim: {
        frames: ['y', 'e', 'l', 'l', 'o', 'w', 'b', 'r', 'i', 'm'],
        interval: 400,
    },
};
//# sourceMappingURL=spinners.js.map